import { render } from "./MarkdownEditor.vue?vue&type=template&id=487a0127&ts=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__